import React from 'react';
import moment from 'moment';
import { NumberInput, DatePicker, DropdownSelector, Modal} from 'hyperdb-utils';
import DefaultPrice from './DefaultPrice';
import PriceMinNights from './PriceMinNights';
import PriceExtraGuests from './PriceExtraGuests';

const SeasonalPricesForm = (props) => {
  // const minYear = moment().subtract(1, 'year').format('YYYY');
  // const maxYear = moment().add(1, 'year').format('YYYY');
  const handleChangeDate = (attributeName, field) => {
    const { value } = field;
    const date = value ? moment(value).format('YYYY-MM-DD') : null;
    props.onChange(attributeName, { value: date });
  };
  const {date_start, date_end} = props.seasonalPrice;
  const openFrom = date_start && date_end ? (date_start < date_end ? date_start : date_end) : date_end || date_start;
  const openTo = date_end && date_start ? (date_end > date_start ? date_end : date_start) : date_start || date_end;
  return (
    <div>
      <fieldset>
        <legend>Dates</legend>
        <DatePicker
          label="From"
          name="from"
          maxValue={ props.seasonalPrice.date_end }
          openToDate={ openFrom }
          value={ props.seasonalPrice.date_start }
          onChange={ handleChangeDate.bind(null, 'date_start') }
        />
      <DatePicker
          label="To"
          name="to"
          minValue={ props.seasonalPrice.date_start }
          openToDate={ openTo }
          value={ props.seasonalPrice.date_end }
          onChange={ handleChangeDate.bind(null, 'date_end') }
          error={ props.errorDates ? 'End date should be >= begin date' : null }
        />
      </fieldset>
      <fieldset>
        <legend>Default Price</legend>
        <DefaultPrice pricesData={ props.seasonalPrice } onChange={ props.onChange } errorBasePrice={ props.errorBasePrice } />
      </fieldset>

      <PriceExtraGuests
        property={ props.property }
        prices={ sortedExtraGuests(props.seasonalPrice.extra_for_extra_guests || []) }
        onChange={ props.onChange.bind(null, 'extra_for_extra_guests') }
      />

      <PriceMinNights
        prices={ sortedMinNights(props.seasonalPrice.variations_for_min_nights || []) }
        onChange={ props.onChange.bind(null, 'variations_for_min_nights') }
      />

    </div>
  );
};

function sortedMinNights(minNights) {
  return minNights.slice().sort((a, b) => a.min_nights - b.min_nights );
}
function sortedExtraGuests(extraGuests) {
  return extraGuests.slice().sort((a, b) => a.nb_extra_guests - b.nb_extra_guests );
}

SeasonalPricesForm.propTypes = {
  seasonalPrice: React.PropTypes.object,
  onChange: React.PropTypes.func,
  errorDates: React.PropTypes.bool,
};

export default SeasonalPricesForm;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/rental-ruleset/components/RentalRulesetEditor/SeasonalPricesForm.jsx